import { render, staticRenderFns } from "./SLED-APIs.vue?vue&type=template&id=20983682"
import script from "./SLED-APIs.vue?vue&type=script&lang=ts"
export * from "./SLED-APIs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports